import React, { useState } from 'react';
import { toast } from 'react-hot-toast';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import { Stack, Typography } from '@mui/material';

import { Props } from './props';
export const CopyText: React.FC<Props> = (props) => {
  const { text = '', renderIcon, textProps, ...restProps } = props;

  // ======================= STATE
  const [isCopied, setIsCopied] = useState(false);

  // ======================= EVENTS
  const onHandleCopy = () => {
    navigator.clipboard.writeText(text);
    setIsCopied(true);
    toast('Copied to clipboard', {
      position: 'bottom-center',
      // theme: 'dark',
      // draggable: false,
      // hideProgressBar: true,
      // autoClose: 1000,
      // transition: Zoom,
      // closeButton: false,
      // icon: null,
    });
    setTimeout(() => {
      setIsCopied(false);
    }, 3000);
  };

  // ======================= VIEWS
  return (
    <Stack direction={'row'} alignItems={'center'} gap={1} {...restProps}>
      <Typography {...textProps}>{text}</Typography>
      {renderIcon ? (
        renderIcon({ onHandleCopy, isCopied })
      ) : (
        <ContentCopyOutlinedIcon
          onClick={onHandleCopy}
          sx={{ width: 16, height: 16, cursor: 'pointer', color: '#545454' }}
        />
      )}
    </Stack>
  );
};

export default CopyText;
